import workflowApi from "../../api/workflowApi";

const state = {};

const actions = {
  async checkDocument(context, docId) {
    return new Promise((resolve, reject) => {
      workflowApi.checkDocument(docId).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });           
    })
  },
};

const mutations = {};

export default { state, actions, mutations };